/**
 * Routini API — Management
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TaxiTripTourChangeType = {
    TourCreated: 'TourCreated',
    TourStarted: 'TourStarted',
    TourFinished: 'TourFinished',
    TourCancelled: 'TourCancelled',
    TourNameChanged: 'TourNameChanged',
    TaxiVehicleChanged: 'TaxiVehicleChanged',
    TaxiDriverAssigned: 'TaxiDriverAssigned',
    TaxiAttendantAssigned: 'TaxiAttendantAssigned',
    TaxiAttendantRemoved: 'TaxiAttendantRemoved',
    TaxiTripAdded: 'TaxiTripAdded',
    TaxiTripRemoved: 'TaxiTripRemoved',
    TaxiTripMoved: 'TaxiTripMoved',
    PredictedPickupTimeChanged: 'PredictedPickupTimeChanged',
    PredictedDropoffTimeChanged: 'PredictedDropoffTimeChanged',
    TourDissolvedInfeasible: 'TourDissolvedInfeasible',
    RouteStopOrderChanged: 'RouteStopOrderChanged',
    RouteStopOrderPinCleared: 'RouteStopOrderPinCleared',
    RouteStopOrderWarningAppeared: 'RouteStopOrderWarningAppeared',
    TourPatternApplied: 'TourPatternApplied',
    TourPatternVehicleNotApplied: 'TourPatternVehicleNotApplied',
    TourPatternAttendantNotApplied: 'TourPatternAttendantNotApplied',
    TourPatternStopOrderNotApplied: 'TourPatternStopOrderNotApplied'
} as const;
export type TaxiTripTourChangeType = typeof TaxiTripTourChangeType[keyof typeof TaxiTripTourChangeType];

